import './index.less';

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  ButtonProps,
} from '@tonic-one/react';
import { memo } from 'react';
import Hide from 'src/components/Common/Hide';
import { MenuOption } from 'src/types';

/**
 * @deprecated replace by @Components/Common/Dropdown, MenuWithLabel have some unexpected bug
 */
const MenuWithLabel = (props: {
  menuItems: MenuOption[];
  minWidth?: number;
  maxWidth?: number;
  variant?: ButtonProps['variant'];
  icon?: any;
  checkedIcon?: any;
  onClick?: any;
  selectedKey: string | number;
  label?: string;
  disabled?: boolean;
}) => {
  const handleClick = (event: any) => {
    const key = event.target.getAttribute('value');
    if (key === null || key === undefined) {
      return;
    }
    props.onClick(event);
  };

  function getValueByKey(menuItems: MenuOption[], key: string | number) {
    const items: MenuOption | undefined = menuItems.find(
      (ele) => ele.key === key
    );
    return items?.value;
  }

  return (
    <Menu display="inline-flex">
      <MenuButton
        variant={props.variant ? props.variant : 'secondary'}
        minWidth={props.minWidth}
        maxWidth={props.maxWidth}
        height={32}
        disabled={props.disabled}
      >
        <Stack direction="row">
          {props.label ? <Text opacity="0.6">{props.label}:&nbsp;</Text> : ''}
          <Text
            size="sm"
            maxWidth={props.maxWidth ? props.maxWidth - 40 : 'auto'}
            overflow={props.maxWidth ? 'hidden' : ''}
            textOverflow={props.maxWidth ? 'ellipsis' : ''}
          >
            {props.icon}
            {getValueByKey(props.menuItems, props.selectedKey)}
          </Text>
        </Stack>
      </MenuButton>
      <MenuList
        className="menuList"
        minWidth={props.minWidth}
        onClick={handleClick}
      >
        {props.menuItems.map((item: MenuOption, i: number) => (
          <MenuItem
            key={i}
            value={item.key}
            style={{ pointerEvents: 'auto', lineHeight: '20px' }}
          >
            {item.value}
            <Hide state={item.key === props.selectedKey}>
              {props.checkedIcon}
            </Hide>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default memo(MenuWithLabel);
